import {i18n} from '@online-offer/i18n';
import {useDateTimeFormatter} from 'platform/locale';

import {isNil} from 'ramda';

import {Nullish, parseDate} from 'shared/web';

export const getFinancialProductValidUntilLabel = (
  validTo: string | Nullish,
  formatDateTime: ReturnType<typeof useDateTimeFormatter>
) =>
  isNil(validTo)
    ? null
    : i18n.t('financialProducts.validUntil', {
        date: formatDateTime('dateShort', parseDate(validTo)),
      });
